import axios from "axios";
import { api } from "./api";

type SignInRequestData = {
  email: string;
  password: string;
  type: string
}

export type OtpChallenge = {
  message: string;
  challenge_id: string;
  expires_in: number;
  retry_after: number;
}

export async function signInRequest(data: SignInRequestData) {
  return axios.post('/api/login', data);
}

export async function requestOtp(email: string) {
  return axios.post<OtpChallenge>('/api/auth/otp/request', {email});
}

export async function verifyOtp(challengeId: string, code: string) {
  return axios.post('/api/auth/otp/verify', {
    challenge_id: challengeId,
    code,
  });
}

export async function requestFellowOtp(email: string) {
  return axios.post<OtpChallenge>('/api/auth/otp/fellow/request', {email});
}

export async function verifyFellowOtp(challengeId: string, code: string) {
  return axios.post('/api/auth/otp/fellow/verify', {
    challenge_id: challengeId,
    code,
  });
}

export async function firstAccess(data: any) {
  return axios.post('/api/firstAccess', data);
}

export async function recoveryPassword(data: any) {
  return axios.post('/api/recoveryPassword', data);
}

export async function recoverUserInformation(type: string = 'boss') {
  const endpoint = type === 'boss' ? 'services-administrator' : 'rar';
  return api.get(`api/${endpoint}/my-profile`);
}

export async function updateUserInformation(data: any, role: string = 'boss') {
  const endpoint = role === 'boss' ? 'services-administrator' : 'rar';
  return api.put(`api/${endpoint}/my-profile`, data);
}

export async function updateUserPassword(data: any, role: string = 'boss') {
  const endpoint = role === 'boss' ? 'services-administrator' : 'rar';
  return api.put(`api/${endpoint}/my-profile/change-password`, data);
}

export async function finishedSubscription() {
  const endpoint= 'rar';
  return api.post(`api/${endpoint}/finished-subscription`);
}
